import styled from 'styled-components';
import Colors from '@/constants/Colors';
import MediaQueryBreakpoints from '@/constants/MediaQueryBreakpoints';

export const StyledAudioQuestionModal = styled.div`
  position: absolute;
  z-index: 100;
  width: 100%;
  height: calc(100% - 60px);

  .question-dialog {
    position: absolute;
    width: auto;
    min-width: 75%;
    height: auto;
    background: white;
    top: 60%;
    left: 50%;
    transform: translate(-50%, -50%);
    padding: 3% 4% 4% 4%;
    user-select: none;
    box-shadow: -2px 3px 15px 2px rgb(0 0 0 / 0.35);
    border-radius: 5px;

    .question-title {
      font-size: calc(12px + ${(props) => props.modalWidth * 0.02}px);
      margin-bottom: 2%;
    }
    .question-options {
      padding: 2% 4% 2% 4%;

      .option-text {
        font-size: calc(11px + ${(props) => props.modalWidth * 0.02}px);
        .playing {
          color: black !important;
        }
      }
      &.answered {
        .ant-radio-disabled + span {
          color: ${Colors.gray};
        }
        .option {
          margin-left: 4px;

          &.selected {
            font-weight: bold;
            transform: scale(1.15) translate(6%, 0);
            transition-property: transform, background-color;
            transition-duration: 0.2s;
            .ant-radio-inner {
              background-color: ${Colors.redBackground} !important;
              border-color: ${Colors.red} !important;
              &::after {
                background-color: ${Colors.red};
              }
            }
            .option-text {
              color: ${Colors.red};
            }
          }
          &.correct {
            .ant-radio-inner {
              border-color: ${Colors.green} !important;
              background-color: ${Colors.greenRadioBackground} !important;
              &::after {
                background-color: ${Colors.green};
              }
            }
            .option-text {
              color: ${Colors.green};
            }
          }
        }
      }
    }
  }
  .feedback {
    margin-top: 8px;
    height: 32px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  @media only screen and (max-width: ${MediaQueryBreakpoints.sm}) {
    .question-dialog {
      width: 80%;
      padding: 10px;
      top: 60%;
      .question-title {
        font-size: 100%;
        font-weight: bold;
      }
      .question-options {
        padding: 5px;
        .option-text {
          font-size: 100%;
        }
      }
    }
  }
`;
